import { render, staticRenderFns } from "./collapse_item.vue?vue&type=template&id=b0badeda"
import script from "./collapse_item.vue?vue&type=script&lang=js"
export * from "./collapse_item.vue?vue&type=script&lang=js"
import style0 from "./collapse_item.vue?vue&type=style&index=0&id=b0badeda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports